export default "__VITE_ASSET__DsGXpBfg__"